import styled from 'styled-components';
import {Paper} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

export const ContentMainStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;    
`;

export const ContentSizeStyled = styled.div`  
  width: 400px;    
  padding: 20px;
`;

export const ContentCNPJBlock = styled.div`
    display: flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
    padding-left: 25px;

    input {
        color: #5d5c5c !important;
    }
`;

export const ModalSuperParent = styled(Paper)`
    width: 100%;
    height: 100vh;
    position: fixed;
    background: #3a3a3abd;
    top: 0;
    left: 0;
    z-index: 9;
`;

export const ModalParent = styled(Paper)`
    width: 80%;
    height: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    padding: 20px;
    overflow-y: auto;

    svg {
        cursor: pointer;
    }
`;

export const CloseButtonModalStyled = styled(CloseIcon)`
    position: absolute;
    right: 10px;
    cursor: pointer;
`;

export const ContentFilterSpaceStyled = styled.div`
    padding-top: 50px;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
    flex-direction: column;
`;

export const DeleteIconStyled = styled(DeleteIcon)`
    cursor: pointer;
`;

export const CleanFilterStyled = styled.div`
    cursor: pointer;
`;